import { useState } from 'react';

import { config } from 'app/config';
import { AudioPlayer } from '../audio-player/audio-player';
import { Content } from './sound-player.styled';

export const SoundPlayer = ({ row }) => {
  const ended = row.disposition === 'ANSWERED';
  const [show, setShow] = useState(false);
  if (!ended) {
    return null;
  }

  const togglePlayer = () => {
    setShow((val) => !val);
  };

  const closePlayer = () => {
    setShow(false);
  };

  const url = config.network.calls_files_url + row.id + '.mp3';

  return (
    <Content>
      <img onClick={togglePlayer} src={show ? '/images/active-speaker.png' : '/images/speaker.png'} alt="" />
      <a target="_blank" rel="noopener noreferrer" href={url}>
        <img src="/images/download.png" alt="" />
      </a>
      {show && <AudioPlayer close={closePlayer} file={url} />}
    </Content>
  );
};
